'use client';

import * as React from 'react';

import { useTranslations } from 'next-intl';

import { GenderButton } from './GenderButton';

type T_Gender = 'men' | 'women';

type T_GenderToggleProps = {
  activeGender: T_Gender;
  onGenderChange: (gender: T_Gender) => void;
};

export function GenderToggle({
  activeGender,
  onGenderChange
}: T_GenderToggleProps) {
  const t = useTranslations('editProfile.avatar');

  return (
    <div className="flex w-full rounded-3xl bg-avatar-tab gap-1 p-1">
      <GenderButton
        gender="women"
        isActive={activeGender === 'women'}
        onClick={() => onGenderChange('women')}
      >
        {t('women')}
      </GenderButton>
      <GenderButton
        gender="men"
        isActive={activeGender === 'men'}
        onClick={() => onGenderChange('men')}
      >
        {t('men')}
      </GenderButton>
    </div>
  );
}
